<template>
  <svg
    width="10"
    height="20"
    viewBox="0 0 10 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ transform: `rotate(${rotate})` }"
  >
    <path
      d="M1.30777 18.6155L8.69238 10.0001L1.30777 1.38477"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#e58413',
    },
    rotate: {
      type: String,
      default: '0',
    },
  },
};
</script>

<style lang="scss" scoped></style>
